import { CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HeaderComponent } from './common/header/header.component';
import { LandingComponent } from './common/landing/landing.component';
import { LoginComponent } from './common/login/login.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule } from '@angular/forms';
import { NgbModule, NgbNavModule } from '@ng-bootstrap/ng-bootstrap'
import {MatTooltipModule} from '@angular/material/tooltip';
import { FnButtonModule, FnChartModule, FnCheckboxFilterModule, FnColorPickerModule, FnDatePickerModule, FnDateRangePickerModule, FnDateTimePickerModule, FnDialogModule, FnEventFilterModule, FnGridModule, FnInputModule, FnLoaderModule, FnMenuModule, FnModalService, FnNoDataBoxModule, FnPaginationModule, FnScrollbarModule, FnSelectModule, FnSwitchModule, FnTableModule, FnTabModule, FnToasterGlobalConfig, FnToasterModule, FnTranslateModule, FnAvtarTextModule, FnBreadcrumbModule, FnTagModule, FnScreenResolutionModule } from 'foundation';
import { JpqlComponent } from './common/landing/jpql/jpql.component';
import { AppRedirectionComponent } from './common/app-redirection/app-redirection.component';
import { HeaderTimeClockComponent } from './common/header/header-time-clock/header-time-clock.component';
import { SearchHeaderComponent } from './common/header/search-header/search-header.component';
import { MatDialogModule } from '@angular/material/dialog';
import { SearchHeaderModalComponent } from './common/header/search-header/search-header-modal/search-header-modal.component';
import { TruncatePipe } from './common/services/truncate.pipe';
import { JpqlLargeDataComponent } from './common/landing/jpql/jpql-large-data/jpql-large-data.component';
import { JpqlParseComponent } from './common/landing/jpql/jpql-parse/jpql-parse.component';
import { JpqlBulkQueriesComponent } from './common/landing/jpql/jpql-bulk-queries/jpql-bulk-queries.component';
import { ToolsComponent } from './common/landing/tools/tools.component';
import { ProductComponent } from './common/landing/tools/product/product.component';
import { EOProductModalComponent } from './common/landing/tools/product/eoproduct-modal/eoproduct-modal.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import { StatusTypeComponent } from './common/landing/tools/status-type/status-type.component';
import { DashboardComponent } from './common/landing/dashboard/dashboard.component';
import { DashboardCommentModelComponent } from './common/landing/dashboard/dashboard-comment-model/dashboard-comment-model.component';
import { DashboardForwordModelComponent } from './common/landing/dashboard/dashboard-forword-model/dashboard-forword-model.component';
import { DashboardInfoModelComponent } from './common/landing/dashboard/dashboard-info-model/dashboard-info-model.component';
import { DashboardMailModelComponent } from './common/landing/dashboard/dashboard-mail-model/dashboard-mail-model.component';
import { DashboardResolvedModelComponent } from './common/landing/dashboard/dashboard-resolved-model/dashboard-resolved-model.component';
import { AlertDisableComponent } from './common/landing/tools/alert-disable/alert-disable.component';
import { AlertDisableModelComponent } from './common/landing/tools/alert-disable/alert-disable-model/alert-disable-model.component';
import { TeamGroupComponent } from './common/landing/tools/team-group/team-group.component';
import { TeamGroupModelComponent } from './common/landing/tools/team-group/team-group-model/team-group-model.component';
import { DashboardChangeSeverityModelComponent } from './common/landing/dashboard/dashboard-change-severity-model/dashboard-change-severity-model.component';
import { DashboardAllCommentModelComponent } from './common/landing/dashboard/dashboard-all-comment-model/dashboard-all-comment-model.component';
import { SetupComponent } from './common/landing/setup/setup.component';
import { ServerHealthComponent } from './common/landing/setup/server-health/server-health.component';
import { DashboardDisableModelComponent } from './common/landing/dashboard/dashboard-disable-model/dashboard-disable-model.component';
import { AppStatusHistoryComponent } from './common/landing/report/app-status-history/app-status-history.component';
import { DashboardAllResolvedComponentComponent } from './common/landing/dashboard/dashboard-all-resolved-component/dashboard-all-resolved-component.component';
import { UtilitySetupComponent } from './common/landing/setup/utility-setup/utility-setup.component';
import { HwHeaderProfileComponentComponent } from './common/header/hw-header-profile-component/hw-header-profile-component.component';
import { DayAppStatusComponent } from './common/landing/report/day-app-status/day-app-status.component';
import { DayAnalysisComponent } from './common/landing/report/day-analysis/day-analysis.component';
import { HealthMonitoringComponent } from './common/landing/health-monitoring/health-monitoring.component';
import { HistInfoModelComponent } from './common/landing/report/app-status-history/hist-info-model/hist-info-model.component';
import { AuditTrailComponent } from './common/landing/audit-trail/audit-trail.component';
import { AlertHelpSetupComponent } from './common/landing/tools/alert-help-setup/alert-help-setup.component';
import { MailTeamComponent } from './common/landing/mailteam/mailteam.component';
import { MailTeamModalComponent } from './common/landing/mailteam/eomailteam-modal/eomailteam-modal.component';
import { ReportComponent } from './common/landing/report/report.component';
import { AlertCompareComponent } from './common/landing/tools/alert-compare/alert-compare.component';
import { InfoGraphModelComponent } from './common/landing/report/day-analysis/info-graph-model/info-graph-model.component';
import { MqStatsComponent } from './common/landing/tools/mqBroker/mq-stats/mq-stats.component';
import { MqBrokerComponent } from './common/landing/tools/mqBroker/mq-broker/mq-broker.component';
import { MqBrokerModelComponent } from './common/landing/tools/mqBroker/mq-broker/mq-broker-model/mq-broker-model.component';
import { MqStatsModelComponent } from './common/landing/tools/mqBroker/mq-stats/mq-stats-model/mq-stats-model.component';
import { HelpVideosComponent } from './common/landing/help-videos/help-videos.component';
import { ErsAppInstanceComponent } from './common/landing/ers-app-instance/ers-app-instance.component';
import { AdminSetupComponent } from './common/landing/setup/admin-setup/admin-setup.component';
import { SlaComponent } from './common/landing/sla/sla.component';
import { SchemaComponent } from './common/landing/tools/schema/schema.component';
import { SchemaTeamModelComponent } from './common/landing/tools/schema/schema-team-model/schema-team.component';

const TOAST_CONFIG: Partial<FnToasterGlobalConfig> = {
  positionClass: 'toast-top-right',
  preventDuplicates: true,
  disableTimeOut: false,
  maxOpened: 1,
  autoDismiss: true,
};
@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    LandingComponent,
    LoginComponent,
    JpqlComponent,
    AdminSetupComponent,
    AppRedirectionComponent,
    HeaderTimeClockComponent,
    SearchHeaderComponent,
    SearchHeaderModalComponent,
    TruncatePipe,
    JpqlLargeDataComponent,
    JpqlParseComponent,
    JpqlBulkQueriesComponent,
    ToolsComponent,
    ProductComponent,
    EOProductModalComponent,
    StatusTypeComponent,
    DashboardComponent,
    DashboardCommentModelComponent,
    DashboardInfoModelComponent,
    DashboardResolvedModelComponent,
    DashboardForwordModelComponent,
    DashboardMailModelComponent,
    AlertDisableComponent,
    AlertDisableModelComponent,
    TeamGroupComponent,
    TeamGroupModelComponent,
    DashboardChangeSeverityModelComponent,
    DashboardAllCommentModelComponent,
    SetupComponent,
    ServerHealthComponent,
    DashboardDisableModelComponent,
    AppStatusHistoryComponent,
    DashboardAllResolvedComponentComponent,
    UtilitySetupComponent,
    HwHeaderProfileComponentComponent,
    DayAppStatusComponent,
    DayAnalysisComponent,
    HealthMonitoringComponent,
    HistInfoModelComponent,
    AuditTrailComponent,
    AlertHelpSetupComponent,
    MailTeamComponent,
    MailTeamModalComponent,
    ReportComponent,
    AlertCompareComponent,
    InfoGraphModelComponent,
    MqStatsComponent,
    MqBrokerComponent,
    MqBrokerModelComponent,
    MqStatsModelComponent,
    HelpVideosComponent,
    ErsAppInstanceComponent,
    SlaComponent,
    SchemaComponent,
    SchemaTeamModelComponent
    ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [
    NgbModule,
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    FnDialogModule,
    FormsModule,
    FnChartModule,
    FnInputModule.forRoot(),
    FnTranslateModule.forRoot(),
    FnButtonModule,
    FnSwitchModule,
    FnTabModule,
    NgbNavModule,
    FnNoDataBoxModule,
    FnDateRangePickerModule,
    FnMenuModule,
    FnTableModule,
    FnToasterModule.forRoot(TOAST_CONFIG),
    FnGridModule,
    FnLoaderModule.forRoot(),
    MatDialogModule,
    FnDatePickerModule,
    FnScrollbarModule,
    FnPaginationModule,
    MatTooltipModule,
    FnColorPickerModule,
    MatProgressSpinnerModule,
    MatProgressBarModule,
    FnEventFilterModule,
    FnSelectModule,
    FnCheckboxFilterModule,
    FnDateTimePickerModule,
    FnAvtarTextModule,
    FnBreadcrumbModule,
    FnTagModule,
    FnScreenResolutionModule
  ],
  providers: [
    FnModalService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
